const PORTAL_BRAND = "Urban Podcasts";

const PORTAL_ROUTE_TITLES = {
    dashboard: "Dashboard",
    settings: "Settings",
    clients: "Clients",
    documents: 'Documents',
    leads: "Leads",
    meetings: "Meetings",
    podcasts: "Podcasts",
    analytics: "Analytics",
    billing: "Billing",
    files: "File Explorer",
    "user-management": "User Management",
    episodes: "Episodes",
    "recording-sessions": "Recording Sessions",
};

function cleanTitlePart(value) {
    return String(value || "")
        .replace(/[\r\n\t]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

export function buildPortalDocumentTitle(...parts) {
    const cleanParts = parts.flat().map(cleanTitlePart).filter(Boolean);
    return [...cleanParts, PORTAL_BRAND].join(" | ");
}

export function getPortalRouteDocumentTitle(page, { authenticated = false } = {}) {
    const rawRoute = cleanTitlePart(page).split("?")[0].replace(/^\/+|\/+$/g, "");
    const route = rawRoute.replace(/^(?:beta|legacy)\//, "");

    if (route.startsWith("review")) return buildPortalDocumentTitle("Episode Review");
    if (route.startsWith('document-sign')) return buildPortalDocumentTitle('Sign Document');
    if (route.startsWith('document-download')) return buildPortalDocumentTitle('Signed Document');
    if (route.startsWith('document-countersign')) return buildPortalDocumentTitle('Countersign Document');
    if (route.startsWith("episode-share")) return buildPortalDocumentTitle("Shared Episode");
    if (route.startsWith("onboarding")) return buildPortalDocumentTitle("Client Onboarding");
    if (route.startsWith("discovery-call")) return buildPortalDocumentTitle("Discovery Call");
    if (route.startsWith("book-discovery")) return buildPortalDocumentTitle("Book a Discovery Call");
    if (route.startsWith("meeting-request")) return buildPortalDocumentTitle("Meeting Request");
    if (route.startsWith("set-password")) return buildPortalDocumentTitle("Set Password");
    if (route.startsWith("recording-sessions/join")) {
        return buildPortalDocumentTitle("Join Recording Studio");
    }
    if (route.startsWith("recording-studio")) {
        return buildPortalDocumentTitle("Recording Studio");
    }
    if (!authenticated) return buildPortalDocumentTitle("Sign In");

    const routeRoot = route.split("/")[0] || "dashboard";
    return buildPortalDocumentTitle(PORTAL_ROUTE_TITLES[routeRoot] || "Dashboard");
}
